export function getSeatingFieldName() {
    return `Seating`;
}
